import React from "react";
import { Col, Tooltip } from "antd";
import _ from "lodash";

const TruncatedEmail = ({
  email,
  style,
  maxLength = 17, // Default max length is 17
  className,
  ...props
}) => {
  const truncateEmail = (email, maxLength) => {
    return _.truncate(email, { length: maxLength, omission: "..." });
  };

  return (
    <Col
      style={{ overflowX: "auto", ...style }}
      span={24}
      className={className}
      {...props}
    >
      <Tooltip title={email || "Email"}>
        <p className="text-xs">{truncateEmail(email, maxLength) || "Email"}</p>
      </Tooltip>
    </Col>
  );
};

export default TruncatedEmail;
